import React, { useEffect } from "react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { CoObjectItem } from "../interfaces/CoObject";
import HeaderPanel from "../layout/HeaderPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { enableMoveCC } from "../../office/ContentControl";
import { closePanel } from "../../index";
import LoadingManager from "../../common/loading/LoadingManager";

export interface MoveProps {
  documentCoObjects: CoObjectItem[];
}

export const MoveObject: React.FunctionComponent<MoveProps> = (props) => {
  let objects = props.documentCoObjects;

  useEffect(() => {
    LoadingManager.create("moveObject");
    enableMove().then(() => LoadingManager.remove("moveObject"));
  }, []);

  async function enableMove() {
    for (const objectItem of objects) {
      await enableMoveCC(objectItem.contentControlId, false);
    }
  }

  async function disableMove() {
    LoadingManager.create("moveObject");
    for (const objectItem of objects) {
      await enableMoveCC(objectItem.contentControlId, true);
    }
    closePanel().then(() => LoadingManager.remove("moveObject"));
  }

  return (
    <>
      <HeaderPanel applyPadding>{formatMessage("cof.base.move")}</HeaderPanel>
      <div
        style={{
          width: "100vw",
          height: "calc(100vh - 5rem)",
          position: "fixed",
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "var(--color-lightblue)",
          zIndex: 1000000,
        }}
      >
        <div
          style={{
            backgroundColor: "var(--color-yellow-a20)",
            fontSize: "1rem",
            margin: "1.25rem 1.25rem 1.25rem 1.25rem",
            padding: "0.5rem 1.25rem 0.5rem 1.25rem",
          }}
        >
          {formatMessage("cof.move.moveobject.alert")}
        </div>
        <img
          src={"/assets/MoveObject.svg"}
          alt={"Move objects"}
          style={{
            minWidth: "120px",
            width: "calc(100vw - 4rem)",
            height: "40vh",
            objectFit: "contain",
          }}
        />
        <span
          style={{
            textAlign: "center",
            color: "var(--color-blue)",
          }}
        >
          {formatMessage("cof.move.moveobject.info")}
        </span>
        <PrimaryButton text={formatMessage("cof.base.done")} onClick={disableMove} style={{ marginTop: "2rem" }} />
      </div>
    </>
  );
};
